import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { DATABASE } from "../Config/firebase";
import { computeYieldFinalSegmentTotals } from "../Utils/fundsPeriodTotals";

const useYieldProductsPeriodTotals = ({ startDate, endDate }) => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(DATABASE, "yields_final"), orderBy("transaction_date", "desc"));
    setLoading(true);
    const unsub = onSnapshot(
      q,
      (snap) => {
        setRecords(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      (err) => {
        console.error("useYieldProductsPeriodTotals: snapshot error", err);
        setLoading(false);
      }
    );
    return unsub;
  }, []);

  const totals = useMemo(() => {
    if (!startDate || !endDate) {
      return {
        individual: { total: 0, count: 0 },
        corporate: { total: 0, count: 0 },
      };
    }
    return computeYieldFinalSegmentTotals(records, { startDate, endDate });
  }, [records, startDate, endDate]);

  return { totals, loading };
};

export default useYieldProductsPeriodTotals;
